import { getTranslationObject } from "./translations/compoundTranslationMapper";

const translationObj = {
    pl: getTranslationObject("pl"),
    en: getTranslationObject("en"),
    de: getTranslationObject("de"),
    fr: getTranslationObject("fr")
};

/**
 * 
 * @param {string} key 
 * @param {string} lang 
 */
export const getTranslationLang = (key, lang = "pl") => {
    if (!lang || !key) {
        return null;
    }
    const langObj = translationObj[lang];
    if (!langObj) {
        return key;
    }
    const compoundKeyMatch = /([A-Za-z_]+)\{(\d+)\}/g.exec(key);
    if (compoundKeyMatch) {
        return getTranslationFromCompoundKey(compoundKeyMatch, langObj, key);
    } else {
        return langObj[key] || key;
    }

}
function getTranslationFromCompoundKey(match, langObj, key) {
    const parsedKey = match[1];
    const index = match[2];
    const translation = langObj[parsedKey];
    if (translation) {
        return resolveTranslationContent(translation, index);
    } else {
        return key;
    }
}

/**
 * {1:translationA}{2: translationB}...{index:desired translation value}
 * @param {string} str whole translation value
 * @param {number} index index
 */
const resolveTranslationContent = (str, index) => {
    const regex = new RegExp(`\\{${index}:([^}]+)}`);
    const match = regex.exec(str);
    if(!match) {
        return str;
    }
    return match[1];
}

let currentLang;
if (localStorage.getItem('langB2B')) {
    currentLang = localStorage.getItem('langB2B');
} else {
    currentLang = "pl";
}

export const getTranslation = (key) => (getTranslationLang(key, currentLang));
export const setLanguage = (newLang) => {
    currentLang = newLang;
    localStorage.setItem('langB2B', newLang);
}
export const getAvailableLanguages = () => Object.keys(translationObj);
export const translationsAreAvailableForLang = (langToCheck) => {
    const langs = getAvailableLanguages();
    for (const lang of langs) {
        if (lang === langToCheck) {
            return true;
        }
    }
    return false;
};
export const getCurrentLang = () => {
    if (localStorage.getItem('langB2B')) {
        return localStorage.getItem('langB2B');
    } else {
        return currentLang;
    }
};
export function getCurrentLangFullName() {
    const langList = ['Polski', 'English', 'Deutsch', 'Français'];
    if (getCurrentLang() === 'pl') {
        return langList[0];
    }
    else if (getCurrentLang() === 'en') {
        return langList[1];
    }
    else if (getCurrentLang() ==='de') {
        return langList[2];
    }
    else if (getCurrentLang() === 'fr') {
        return langList[3];
    }
    else {
        return langList[0];
    }
}

const getBrowserLang = () => {
    return (navigator.languages) ||
        navigator.language ||
        navigator.userLanguage
}

const trySetLanguage = (lang) => {
    if (lang.length < 2) {
        return false;
    }
    const code = lang.slice(0, 2);
    if (translationsAreAvailableForLang(code)) {
        setLanguage(code);
        return true;
    }
    return false;
}

export const setLangByShopId = (shoplangId) => {
    const langs={
        "1":"pl",
        "2":"en",
        "3":"de",
        "5":"fr",
        "12":"es"
    }
    if(!shoplangId || !langs[shoplangId]) {
        throw new Error("invalid langId");
    }
    trySetLanguage(langs[shoplangId]);
}

export const SetLanguageDependingOnBrowserSettings = () => {
    const detect = getBrowserLang();
    //undetected => polish by default, do nothing
    if (!detect) {
        return;
    }
    if (typeof detect === "string") {
        trySetLanguage(detect)
    }
    if (typeof detect !== "string" && Array.isArray(detect)) {
        for (const item of detect) {
            if (trySetLanguage(item)) {
                break;
            }
        }
    }
}